import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalTitle,
} from 'react-bootstrap';

const QuestionOptionModal = (props) => {
  return (
    <Modal
      style={{ zIndex: '5000' }}
      show={props.show}
      onHide={props.toggle}
      size="lg"
    >
      <ModalTitle>
        <span className="m-3 mt-2">Options</span>
      </ModalTitle>
      <ModalBody>
        <div
          className="d-flex align-items-center"
          style={{ justifyContent: 'space-between' }}
        >
          <Button className="" onClick={props.addOptions}>
            Add
          </Button>
          <div className="form-check">
            <input
              type={'checkbox'}
              className=" form-check-input"
              id="isSingle"
              checked={props.isSingle}
              onChange={(e) => props.handleChange(false, e.target.checked)}
            />
            <label
              className="mx-1 fs-20 fw-bold form-check-label"
              htmlFor="isSingle"
            >
              Single Select
            </label>
          </div>
        </div>
        {/* Header Row */}
        <div style={{ display: 'flex', fontWeight: 'bold', marginTop: 16, marginBottom: 8, gap: 8 }}>
          <div style={{ flex: 3 }}>Value</div>
          <div style={{ flex: 1, textAlign: 'center' }}>is_critical</div>
          <div style={{ flex: 1, textAlign: 'center' }}>important</div>
          <div style={{ flex: 1, textAlign: 'center' }}>none</div>
          <div style={{ width: 32 }}></div>
        </div>
        {/* Option Rows */}
        {props.options?.map((el, index) => {
          // Backward compatibility: convert string to object
          const option = typeof el === 'string' ? { value: el } : el || { value: '' };
          // Determine radio selection
          let radioValue = 'none';
          if (option.important) radioValue = 'important';
          else if (option.is_critical) radioValue = 'is_critical';
          return (
            <div
              key={index}
              style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}
            >
              {/* Value input */}
              <input
                className="form-input m-1 p-1"
                style={{ flex: 3, minWidth: 240 }}
                id={`option-value-${index}`}
                type="text"
                placeholder="Option"
                value={option.value || ''}
                onChange={(e) => {
                  const updated = { ...option, value: e.target.value };
                  if (!updated.important) delete updated.important;
                  if (!updated.is_critical) delete updated.is_critical;
                  props.handleChange(index, updated);
                }}
              />
              {/* is_critical radio */}
              <div style={{ flex: 1, textAlign: 'center' }}>
                <input
                  type="radio"
                  name={`option-flag-${index}`}
                  checked={radioValue === 'is_critical'}
                  style={{ width: 20, height: 20, accentColor: '#007bff', verticalAlign: 'middle', appearance: 'auto', WebkitAppearance: 'radio', MozAppearance: 'radio' }}
                  onChange={() => {
                    const updated = { ...option, is_critical: true };
                    delete updated.important;
                    props.handleChange(index, updated);
                  }}
                />
              </div>
              {/* important radio */}
              <div style={{ flex: 1, textAlign: 'center' }}>
                <input
                  type="radio"
                  name={`option-flag-${index}`}
                  checked={radioValue === 'important'}
                  style={{ width: 20, height: 20, accentColor: '#007bff', verticalAlign: 'middle', appearance: 'auto', WebkitAppearance: 'radio', MozAppearance: 'radio' }}
                  onChange={() => {
                    const updated = { ...option, important: true };
                    delete updated.is_critical;
                    props.handleChange(index, updated);
                  }}
                />
              </div>
              {/* none radio */}
              <div style={{ flex: 1, textAlign: 'center' }}>
                <input
                  type="radio"
                  name={`option-flag-${index}`}
                  checked={radioValue === 'none'}
                  style={{ width: 20, height: 20, accentColor: '#007bff', verticalAlign: 'middle', appearance: 'auto', WebkitAppearance: 'radio', MozAppearance: 'radio' }}
                  onChange={() => {
                    const updated = { ...option };
                    delete updated.important;
                    delete updated.is_critical;
                    props.handleChange(index, updated);
                  }}
                />
              </div>
              {/* Delete icon */}
              <div style={{ width: 32, textAlign: 'center' }}>
                <FontAwesomeIcon
                  className="m-1"
                  onClick={() => props.deleteOption(index)}
                  icon={faTrash}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            </div>
          );
        })}
      </ModalBody>
      <ModalFooter>
        <div className="d-flex">
          <Button onClick={props.toggle}>Close</Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default QuestionOptionModal;
